import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ProjectsNav from './components/ProjectsNav';
import ProjectsFooter from './components/ProjectsFooter';
import EmberDivider from '@/pages/home/components/EmberDivider';

interface Project {
  title: string;
  client: string;
  categories: string[];
  videoUrl?: string;
  videoType: 'youtube' | 'mp4' | 'page';
  thumbnail: string;
}

const allProjects: Project[] = [
  {
    title: 'KAYO — Social Edit',
    client: 'Anna Schriver',
    categories: ['Video Editing', 'Videography', 'Creative Direction'],
    videoUrl: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/514093d3-152b-449e-8ee5-6fa9d62a1d0a_kayo-wsy-post-Anna-Schriver.mp4?v=a5dd6208ed530f27758e1de92f7fd0a2',
    videoType: 'mp4',
    thumbnail: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/8975b03f-5e87-4896-b316-fa9122432641_kayo-thumbnail-Anna-Schriver.jpg?v=6bb89026fac7eb2b72c63ee2cd1e9ef8',
  },
  {
    title: "BUFFS — CU MEN'S BASKETBALL",
    client: 'Anna Schriver',
    categories: ['Video Editing'],
    videoUrl: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/e2c658d8-482f-40ef-b92c-f683802b06bd_mbb-aplication-vid-Anna-Schriver.mp4?v=326f16f5d37c8229dec052649926d72e',
    videoType: 'mp4',
    thumbnail: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/b2195d79-ca75-4884-a3a0-20c411336d99_mbb-thumbnial-1-Anna-Schriver.jpg?v=dde51840bd2e56f6856c7328a63fd1dd',
  },
  {
    title: 'Pi Beta Phi Brand Film',
    client: 'Anna Schriver',
    categories: ['Video Editing', 'Videography', 'Creative Direction'],
    videoUrl: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/b511e14a-2fc9-4ab4-b905-b2d3529080ef_Piphi-Finalmp4-Anna-Schriver.mp4?v=d3a9dcda7f6a8e987af589827f4a9b85',
    videoType: 'mp4',
    thumbnail: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/9194b4bd-68b7-4390-b10b-8d1f173b4aea_piphi-thumbnail-Anna-Schriver.jpg?v=03063ae3dd6f931a6f63ce3ee1988a5b',
  },
  {
    title: 'Poly Bowl — Game Day',
    client: 'Anna Schriver',
    categories: ['Video Editing', 'Videography'],
    videoUrl: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/6b95de26-cc79-4d62-afa5-0a5a58260181_poly-bowl-Anna-Schriver.mp4?v=450616451915eae4603705862316e9c5',
    videoType: 'mp4',
    thumbnail: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/3f4d563a-06b1-4c49-a1a2-8053148a97e2_polybowl-thumbnail-2-Anna-Schriver.jpg?v=9c3c8b2061b93aeb289985bb7f3c7029',
  },
  {
    title: 'Playoffs — RHS vs Prep',
    client: 'Anna Schriver',
    categories: ['Video Editing', 'Videography'],
    videoUrl: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/f00d9140-e9e9-40ce-8567-9dbd937ff881_Rhs-vs-Prep-2024-final-render-Anna-Schriver.mp4?v=358ed46d3ab5421fef055e51d71ba38c',
    videoType: 'mp4',
    thumbnail: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/ac280c56-f3bd-42ca-908e-03fa17d68a79_rhs-vs-prep-tn-Anna-Schriver.jpg?v=7f55258e23aeef6be3c80f3c34191cdf',
  },
  {
    title: 'NCAA Hype Video',
    client: 'Anna Schriver',
    categories: ['Video Editing', 'Videography'],
    videoUrl: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/08f971b9-62b6-4bc0-b7c9-0808f24d29cf_Soccer.--1-Anna-Schriver.mp4?v=b5feae2229098e861271818371e1f5ad',
    videoType: 'mp4',
    thumbnail: 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/89b1c2f1-9bcb-448e-86c6-75ddf1616c7b_soccer-thumbnail-1-Anna-Schriver.jpg?v=b329d000d32ffbb946ad027bb2ff7cd9',
  },
];

const categories = ['ALL', 'Creative Direction', 'Video Editing', 'Videography'];
const BLUE_GREY = '#5b8ab5';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const projectsSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Projects — Anna Schriver | Filmmaker & Video Editor',
  description: 'Browse Anna Schriver\'s portfolio of filmmaking, video editing, and creative direction projects including brand films, sports hype videos, and social edits.',
  url: `${SITE_URL}/projects`,
  author: {
    '@type': 'Person',
    name: 'Anna Schriver',
    url: SITE_URL,
    jobTitle: 'Filmmaker, Video Editor & Creative Director',
    sameAs: ['https://www.instagram.com/anna_schriver/'],
  },
  about: { '@type': 'Person', name: 'Anna Schriver' },
  hasPart: [
    { '@type': 'VideoObject', name: 'KAYO — Social Edit', description: 'Social media video edit by Anna Schriver', author: { '@type': 'Person', name: 'Anna Schriver' } },
    { '@type': 'VideoObject', name: "BUFFS — CU Men's Basketball", description: 'CU Men\'s Basketball hype video by Anna Schriver', author: { '@type': 'Person', name: 'Anna Schriver' } },
    { '@type': 'VideoObject', name: 'Pi Beta Phi Brand Film', description: 'Brand film for Pi Beta Phi by Anna Schriver', author: { '@type': 'Person', name: 'Anna Schriver' } },
    { '@type': 'VideoObject', name: 'Poly Bowl — Game Day', description: 'Game day video for Poly Bowl by Anna Schriver', author: { '@type': 'Person', name: 'Anna Schriver' } },
    { '@type': 'VideoObject', name: 'Playoffs — RHS vs Prep', description: 'Playoff game highlight video by Anna Schriver', author: { '@type': 'Person', name: 'Anna Schriver' } },
    { '@type': 'VideoObject', name: 'NCAA Hype Video', description: 'NCAA soccer hype video by Anna Schriver', author: { '@type': 'Person', name: 'Anna Schriver' } },
  ],
};

function ProjectCard({ project }: { project: Project }) {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleFullscreen = (e: React.MouseEvent) => {
    e.stopPropagation();
    const video = videoRef.current;
    if (!video) return;
    // Standard fullscreen
    if (video.requestFullscreen) {
      video.requestFullscreen();
    // iOS Safari webkit fullscreen
    } else if ((video as HTMLVideoElement & { webkitEnterFullscreen?: () => void }).webkitEnterFullscreen) {
      (video as HTMLVideoElement & { webkitEnterFullscreen: () => void }).webkitEnterFullscreen();
    }
  };

  return (
    <div
      className="group relative overflow-hidden cursor-pointer"
      style={{ aspectRatio: '4/3' }}
      onClick={() => { if (!playing && project.videoUrl) setPlaying(true); }}
    >
      {playing && project.videoUrl ? (
        <div className="absolute inset-0 w-full h-full" style={{ background: '#000' }}>
          {project.videoType === 'mp4' ? (
            <video
              ref={videoRef}
              src={project.videoUrl}
              className="w-full h-full border-0"
              autoPlay
              controls
              playsInline
            />
          ) : (
            <iframe
              src={project.videoUrl}
              title={project.title}
              className="w-full h-full border-0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          )}
          <button
            className="absolute top-3 right-3 z-50 w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200"
            style={{ background: 'rgba(0,0,0,0.75)', border: '1px solid rgba(255,255,255,0.25)' }}
            onClick={(e) => { e.stopPropagation(); setPlaying(false); }}
          >
            <i className="ri-close-line text-white text-lg"></i>
          </button>
          {/* Fullscreen button — uses native video fullscreen for iOS Safari compatibility */}
          {project.videoType === 'mp4' && (
            <div
              className="absolute bottom-3 right-3 z-50 flex items-center gap-1.5 px-3 py-1.5 rounded cursor-pointer opacity-70 hover:opacity-100 transition-opacity duration-200"
              style={{ background: 'rgba(0,0,0,0.65)', border: '1px solid rgba(255,255,255,0.15)' }}
              onClick={handleFullscreen}
            >
              <i className="ri-fullscreen-line text-white text-sm"></i>
              <span className="text-white text-xs uppercase tracking-widest hidden sm:inline">Fullscreen</span>
            </div>
          )}
        </div>
      ) : (
        <>
          {/* Thumbnail image */}
          <div className="absolute inset-0 w-full h-full group-hover:scale-105 transition-transform duration-700">
            <img
              src={project.thumbnail}
              alt={project.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Black mist overlay — moody base */}
          <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.50) 30%, rgba(0,0,0,0.28) 60%, rgba(0,0,0,0.55) 100%)',
          }} />

          {/* Black mist — soft smoky diffusion across the whole frame */}
          <div className="absolute inset-0 pointer-events-none" style={{
            background: `
              radial-gradient(ellipse 160% 80% at 50% 0%,   rgba(0,0,0,0.55) 0%, transparent 65%),
              radial-gradient(ellipse 160% 80% at 50% 100%, rgba(0,0,0,0.60) 0%, transparent 65%),
              radial-gradient(ellipse 80% 160% at 0%   50%, rgba(0,0,0,0.40) 0%, transparent 60%),
              radial-gradient(ellipse 80% 160% at 100% 50%, rgba(0,0,0,0.40) 0%, transparent 60%)
            `,
          }} />

          {/* Subtle film grain */}
          <div className="absolute inset-0 pointer-events-none opacity-15" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'1\'/%3E%3C/svg%3E")',
            backgroundSize: '128px 128px',
            mixBlendMode: 'overlay',
          }} />

          {/* Play button on hover */}
          {project.videoUrl && (
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div
                className="w-16 h-16 flex items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110"
                style={{ background: 'rgba(255,255,255,0.10)', border: '2px solid rgba(255,255,255,0.55)', backdropFilter: 'blur(6px)' }}
              >
                <i className="ri-play-fill text-white text-2xl ml-1"></i>
              </div>
            </div>
          )}

          {/* Title info */}
          <div className="absolute bottom-6 left-6 right-6">
            <p className="text-white/50 text-xs uppercase tracking-widest mb-1">{project.client}</p>
            <h3 className="text-white uppercase leading-tight" style={{ fontSize: '1.15rem', fontWeight: 900 }}>{project.title}</h3>
          </div>
        </>
      )}
    </div>
  );
}

export default function ProjectsPage() {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const navigate = useNavigate();

  useEffect(() => {
    const id = 'schema-projects';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(projectsSchema);
    document.title = 'Projects — Anna Schriver | Filmmaker & Video Editor';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Browse Anna Schriver\'s portfolio of filmmaking, video editing, and creative direction projects including brand films, sports hype videos, and social edits.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/projects`);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  const filtered = activeCategory === 'ALL'
    ? allProjects
    : allProjects.filter((p) => p.categories.includes(activeCategory));

  const handleGetInTouch = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/contact');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden" style={{ background: '#0d0d0f' }}>
      <ProjectsNav />

      <div className="pt-12 pb-12 px-4 md:px-8 max-w-7xl mx-auto">
        <h1 className="text-white text-center leading-none mb-10" style={{ fontSize: 'clamp(3rem, 12vw, 9rem)', fontWeight: 900 }}>
          PROJECTS
        </h1>

        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className="px-4 md:px-5 py-2 text-xs font-bold tracking-widest uppercase border transition-colors duration-200 cursor-pointer whitespace-nowrap rounded-md"
              style={
                activeCategory === cat
                  ? { background: BLUE_GREY, borderColor: BLUE_GREY, color: '#fff' }
                  : { background: 'transparent', borderColor: 'rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.6)' }
              }
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {filtered.map((project) => (
            <ProjectCard key={project.title} project={project} />
          ))}
        </div>
      </div>

      <EmberDivider />

      <div className="py-20 md:py-28 px-4 md:px-8 text-center relative overflow-hidden" style={{ background: '#0d0d0f' }}>
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full" style={{ background: 'radial-gradient(circle, rgba(91,138,181,0.08) 0%, transparent 70%)' }}></div>
        </div>
        <h2 className="text-white leading-none mb-10" style={{ fontSize: 'clamp(4rem, 10vw, 8rem)' }}>
          <div style={{ fontWeight: 100 }}>LET&apos;S</div>
          <div style={{ fontWeight: 900 }}>WORK!</div>
        </h2>
        <a
          href="/contact"
          onClick={handleGetInTouch}
          className="inline-block text-white px-10 py-4 text-sm font-bold tracking-widest uppercase cursor-pointer whitespace-nowrap rounded-md btn-glow"
          style={{ background: BLUE_GREY }}
        >
          GET IN TOUCH
        </a>
      </div>

      <ProjectsFooter />
    </div>
  );
}
